export const iconFontAwesomeMapsBeerMugEmpty = (
	<i className="fa-solid fa-beer-mug-empty"></i>
);
